import product1 from "../assets/images/product-1.webp";
import product2 from "../assets/images/product-2.webp";
import product3 from "../assets/images/product-3.webp";
import product4 from "../assets/images/product-4.webp";
import product5 from "../assets/images/product-5.webp";
import product6 from "../assets/images/product-6.webp";
import product7 from "../assets/images/product-7.webp";
import product8 from "../assets/images/product-8.webp";
import product9 from "../assets/images/product-9.webp";
import product10 from "../assets/images/product-10.webp";
import product11 from "../assets/images/product-11.webp";
import product12 from "../assets/images/product-12.webp";
import product13 from "../assets/images/product-13.webp";
import product14 from "../assets/images/product-14.webp";
import product15 from "../assets/images/product-15.webp";
import product16 from "../assets/images/product-16.webp";
import product17 from "../assets/images/product-17.webp";
import product18 from "../assets/images/product-18.webp";
import product19 from "../assets/images/product-19.webp";
import product20 from "../assets/images/product-20.webp";
import category1 from "../assets/images/category-1.webp";
import category2 from "../assets/images/category-2.webp";
import category3 from "../assets/images/category-3.webp";
import category4 from "../assets/images/category-4.webp";

export const itemImages = {
	1: product1,
	2: product2,
	3: product3,
	4: product4,
	5: product5,
	6: product6,
	7: product7,
	8: product8,
	9: product9,
	10: product10,
	11: product11,
	12: product12,
	13: product13,
	14: product14,
	15: product15,
	16: product16,
	17: product17,
	18: product18,
	19: product19,
	20: product20,
};

// export const itemImages = [
// 	{
// 		name: "product1",
// 		image: product1,
// 	},
// 	{
// 		name: "product2",
// 		image: product2,
// 	},
// 	{
// 		name: "product3",
// 		image: product3,
// 	},
// 	{
// 		name: "product4",
// 		image: product4,
// 	},
// 	{
// 		name: "product5",
// 		image: product5,
// 	},
// 	{
// 		name: "product6",
// 		image: product6,
// 	},
// 	{
// 		name: "product7",
// 		image: product7,
// 	},
// 	{
// 		name: "product8",
// 		image: product8,
// 	},
// 	{
// 		name: "product9",
// 		image: product9,
// 	},
// 	{
// 		name: "product10",
// 		image: product10,
// 	},
// 	{
// 		name: "product11",
// 		image: product11,
// 	},
// 	{
// 		name: "product12",
// 		image: product12,
// 	},
// 	{
// 		name: "product13",
// 		image: product13,
// 	},
// 	{
// 		name: "product14",
// 		image: product14,
// 	},
// 	{
// 		name: "product15",
// 		image: product15,
// 	},
// 	{
// 		name: "product16",
// 		image: product16,
// 	},
// 	{
// 		name: "product17",
// 		image: product17,
// 	},
// 	{
// 		name: "product18",
// 		image: product18,
// 	},
// 	{
// 		name: "product19",
// 		image: product19,
// 	},
// 	{
// 		name: "product20",
// 		image: product20,
// 	},
// ];

export const categoryImages = [
	{
		name: "category1",
		image: category1,
	},
	{
		name: "category2",
		image: category2,
	},
	{
		name: "category3",
		image: category3,
	},
	{
		name: "category4",
		image: category4,
	},
];
